<template>
  <PageWrapper
    :active-section="SECTION_HOME"
    :active-page="PAGE_HOME"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap">
      <FeedSideBar v-if="isNewHomeFeedEnabled" />
      <SmartFeed
        :pinia-store="homeFeedStore"
        default-smart-feed-layout="grid"
        default-entity-layout="cardLarge"
        load-more-behavior="auto"
      />
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_HOME, PAGE_HOME } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import FeedSideBar from "@/components/FeedSideBar.vue";
import { useFeatureStore } from "%/stores/feature-store";
import { useHomeCommunityPostFeedStore } from "SmartFeed/stores/feed/home-community-post-feed-store";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";

export default {
  name: "Home",
  components: {
    PageWrapper,
    SmartFeed,
    FeedSideBar,
  },
  data() {
    return {
      SECTION_HOME,
      PAGE_HOME,
    };
  },
  computed: {
    isNewHomeFeedEnabled() {
      return useFeatureStore().isFeatureEnabled("userHomeFeed");
    },
    homeFeedStore() {
      if (this.isNewHomeFeedEnabled) {
        return SmartFeedEngine.getFeedPiniaStore("HomeFeedSource");
      }
      return useHomeCommunityPostFeedStore;
    },
  },
};
</script>
